import React from 'react';
import { observer } from 'mobx-react';
import { useSelectionStore } from '@assets/model/StoreSelection';
import { Flex } from '@assets/component/UI/Flex/Flex';

export const FloatingSelectionPanel: React.FC = observer(() => {
    const selectionStore = useSelectionStore();
    
    return (
        <Flex
            direction="column"
            style={{
                position: 'fixed',
                right: '20px',
                bottom: '20px',
                padding: '16px',
                backgroundColor: '#ffffff',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                zIndex: 10000,
                minWidth: '240px',
                gap: '12px'
            }}
        >
            <div style={{ 
                fontSize: '16px',
                fontWeight: 600,
                color: '#333333',
                marginBottom: '8px',
                borderBottom: '1px solid #e0e0e0',
                paddingBottom: '8px'
            }}>
                Reference Data Selection
            </div>
            
            {selectionStore.existingDataFound && (
                <div style={{ 
                    fontSize: '12px',
                    color: '#2e7d32',
                    marginBottom: '4px'
                }}>
                    Existing reference data found
                </div>
            )}
            
            <div style={{ 
                fontSize: '14px',
                color: '#333333',
                marginBottom: '8px'
            }}>
                {selectionStore.selectionCount} fields selected
            </div>
            
            <Flex justify="between" style={{ gap: '8px' }}>
                <button 
                    onClick={() => selectionStore.selectAll()}
                    style={{
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 500,
                        backgroundColor: '#F9FAFB',
                        color: '#333333'
                    }}
                >
                    Select All
                </button>
                
                <button 
                    onClick={() => selectionStore.exitSelectionMode()}
                    style={{
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 500,
                        backgroundColor: '#F9FAFB',
                        color: '#333333'
                    }}
                >
                    Cancel
                </button>
                
                <button 
                    onClick={() => selectionStore.saveSelected()}
                    style={{
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 500,
                        backgroundColor: '#1976d2',
                        color: '#ffffff'
                    }}
                >
                    Save Selected
                </button>
            </Flex>
        </Flex>
    );
}); 